import { render } from "./warehousing.vue?vue&type=template&id=6007e823"
import script from "./warehousing.vue?vue&type=script&lang=js"
export * from "./warehousing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__